import './index.scss';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
// import PropTypes from 'prop-types';
import CustomiseScreen from '../../containers/CustomiseScreen';
import Modal from '../../containers/modal';

class InfinteScreen extends Component {
  renderContent = () => {
    const dom = (
      <CustomiseScreen
        onCloseHandler={this.onCloseModalHandler}
        {...this.props}
      />
    );
    return dom;
  };

  // onCloseModalHandler = () => {
  //   const { onCloseModalHandler } = this.props;
  //   onCloseModalHandler();
  // };

  render() {
    const { theme } = this.props;
    return (
      <Modal
        isMobileFullLayout={window?.innerWidth < 1023}
        onCloseHandler={this.props?.otherPopUpHide}
        hideClose
        contentCustomClass={window?.innerWidth > 1023 && 'customise-class'}
      >
        <div className={`feedback ${theme}`}>
          {this.renderContent({ ...this.props })}
        </div>
      </Modal>
    );
  }
}

export default withRouter(InfinteScreen);
